import React from "react";
import { ProgressBar } from "react-bootstrap";

const EnrollmentbySite = ({ siteData }) => {
  const defaultSiteData = [
    { id: "101", name: "Memorial Cancer Center", randomized: 2, screened: 2 },
    { id: "102", name: "Riverside Oncology Institute", randomized: 2, screened: 2 },
    { id: "201", name: "Universitätsklinikum Frankfurt", randomized: 1, screened: 2 },
    { id: "202", name: "Charité Berlin", randomized: 1, screened: 2 },
  ];

  const data = siteData || defaultSiteData;
  
  const totalScreened = data.reduce((sum, site) => sum + site.screened, 0);
  const totalRandomized = data.reduce((sum, site) => sum + site.randomized, 0);
  const totalSites = data.length;
  const maxEnrollment = Math.max(...data.map(site => Math.max(site.screened, site.randomized)), 10);

  return (
    <div className="enrollment-by-site">
      {data.map((site) => {
        const screenedPercent = (site.screened / maxEnrollment) * 100;
        const randomizedPercent = (site.randomized / maxEnrollment) * 100;
        
        return (
          <div key={site.id} className="mb-3">
            <div className="d-flex justify-content-between align-items-center">
              <span className="fw-semibold" style={{ fontSize: "13px" }}>
                Site {site.id} · {site.name}
              </span>
              <span style={{ fontSize: "13px" }}>
                <span className="text-primary fw-bold">{site.randomized} rand</span> /{" "}
                <span className="text-success fw-bold">{site.screened} scr</span>
              </span>
            </div>
            
            <div className="mt-1">
              <div className="hstack gap-2">
                <span style={{ fontSize: "11px", minWidth: "65px", color: "#198754" }}>
                  Screened
                </span>
                <ProgressBar 
                  variant="success" 
                  now={Math.min(screenedPercent, 100)} 
                  style={{ 
                    height: "8px", 
                    width: "100%",
                    backgroundColor: "#e9ecef",
                    borderRadius: "4px"
                  }}
                />
                <span style={{ fontSize: "12px", minWidth: "30px", fontWeight: 600, color: "#198754" }}>
                  {site.screened}
                </span>
              </div>
              
              {/* Randomized Progress Bar with Label */}
              <div className="hstack gap-2 mt-1">
                <span style={{ fontSize: "11px", minWidth: "65px", color: "#0d6efd" }}>
                  Randomized
                </span>
                <ProgressBar 
                  variant="primary" 
                  now={Math.min(randomizedPercent, 100)} 
                  style={{ 
                    height: "8px", 
                    width: "100%",
                    backgroundColor: "#e9ecef",
                    borderRadius: "4px"
                  }}
                />
                <span style={{ fontSize: "12px", minWidth: "30px", fontWeight: 600, color: "#0d6efd" }}>
                  {site.randomized}
                </span>
              </div>
            </div>
          </div>
        );
      })}

      {/* Stats Footer */}
      <div className="d-flex justify-content-between mt-2 pt-2 border-top">
        <div className="hstack gap-3">
          <span style={{ fontSize: "12px" }}>
            <span className="text-success">●</span> Total Screened: <strong>{totalScreened}</strong>
          </span>
          <span style={{ fontSize: "12px" }}>
            <span className="text-primary">●</span> Total Randomized: <strong>{totalRandomized}</strong>
          </span>
        </div>
        <span style={{ fontSize: "12px" }}>
          <strong>{totalSites}</strong> Sites
        </span>
      </div>
    </div>
  );
};

export default EnrollmentbySite;